/**
 * Store for managing the Table Explorer dialog state.
 * Allows any part of the app to trigger the dialog opening.
 */

import { create } from 'zustand';
import type { DatabaseEngineId } from '../../../../core/engines';

/** What to do when the user picks a table from the dialog. */
export type TableExplorerDialogPurpose = 'open-explorer' | 'open-profile' | 'migrate-table';

type TableExplorerDialogState = {
  isOpen: boolean;
  connectionId: string;
  connectionName: string;
  serverHost: string;
  database: string;
  engineId: DatabaseEngineId;
  purpose: TableExplorerDialogPurpose;
};

type TableExplorerDialogActions = {
  openDialog: (params: {
    connectionId: string;
    connectionName: string;
    serverHost: string;
    database: string;
    engineId?: DatabaseEngineId;
    purpose?: TableExplorerDialogPurpose;
  }) => void;
  closeDialog: () => void;
};

type TableExplorerDialogStore = TableExplorerDialogState & TableExplorerDialogActions;

const initialState: TableExplorerDialogState = {
  isOpen: false,
  connectionId: '',
  connectionName: '',
  serverHost: '',
  database: '',
  engineId: 'mssql',
  purpose: 'open-explorer',
};

export const useTableExplorerDialogStore = create<TableExplorerDialogStore>((set) => ({
  ...initialState,

  openDialog: (params) =>
    set({
      isOpen: true,
      connectionId: params.connectionId,
      connectionName: params.connectionName,
      serverHost: params.serverHost,
      database: params.database,
      engineId: params.engineId ?? 'mssql',
      purpose: params.purpose ?? 'open-explorer',
    }),

  closeDialog: () =>
    set({
      isOpen: false,
    }),
}));
